import React from "react";
import StatusBadge from '../../Components/shared/status.jsx';
import PageLayout from '../../Components/PageLayout';
import { useDevices } from "../../hooks/useDevices";
import "../../Css/Devices.css";

function Nestlink() {
  // Use the useDevices hook instead of useState and useEffect
  const { data: hubs = [], isLoading, error } = useDevices();

  // Funkcja formatująca czas ostatniego połączenia
  const formatLastSeen = (lastSeen) => {
    if (!lastSeen) return '';
    
    try {
      const lastDate = new Date(lastSeen);
      return lastDate.toLocaleString();
    } catch (e) {
      return lastSeen;
    }
  };

  return (
    <PageLayout title="NestLink Devices" subtitle="NestLink devices overview">
      <div className="flex title-box">
        <p className="small-text">Search</p>
        <input className="devices-search top-border" type="text" />
        <button className="filter-btn top-border">Filter</button>
      </div>

      <div className="devices-list">
        <table className="devices-table">
          <thead>
            <tr className='table-header'>
              <th className='small-text table-thumb'>Icon</th>
              <th className='table-title'>Name</th>
              <th className='table-devices table-model'>Version</th>
              <th className='table-devices'>OS</th>
              <th className='table-devices'>Status</th>
              <th className='table-devices'>UUID</th>
              <th className='table-devices'></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" style={{textAlign: "center", padding: "20px"}}>
                  Loading...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" style={{textAlign: "center", padding: "20px", color: "red"}}>
                  Error loading devices: {error.message}
                </td>
              </tr>
            ) : hubs.length > 0 ? (
              hubs.map((hub) => (
                <tr className="table-devices-tr" key={hub.id}>
                  <td className="avatar-cell">{hub.thumb}</td>
                  <td>{hub.name}</td>
                  <td><div className="td-rounded">{hub.version}</div></td>
                  <td><div className="td-rounded">{hub.os}</div></td>
                  <td className="status-cell">
                    <StatusBadge status={hub.status} showLabel={true} />
                    {hub.status === 0 && hub.lastSeen && (
                      <div className="last-seen-info">
                        Last seen: {formatLastSeen(hub.lastSeen)}
                      </div>
                    )}
                  </td>
                  <td className="small-text">{hub.uuid.substring(0, 8)}...</td>
                  <td><button className="options">...</button></td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{textAlign: "center", padding: "20px"}}>
                  No NestLink hubs available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </PageLayout>
  );
}

export default Nestlink;
